/**
 * The <main> of a page: one width and one set of gutters for all of them.
 *
 * Its direct children are laid out edge to edge inside those gutters (see
 * .page-main in index.css), so a page adds its content and does not repeat
 * the page's own measurements. `className` carries what a particular page
 * still needs (article-page, account-page, ...).
 */
function PageMain({ className, children }) {
  return (
    <main className={['main', 'page-main', className].filter(Boolean).join(' ')}>
      {children}
    </main>
  );
}

export default PageMain;
